import { IconFont } from '@/components/IconFont'
import { Menu } from 'antd'
import classnames from 'classnames'
import React, { memo, useMemo } from 'react'
import { useNavigate } from 'react-router'
import { Outlet, useMatch } from 'react-router-dom'
import styles from './index.module.less'

export default memo(function Settings() {
  const navigate = useNavigate()
  const match = useMatch('/settings/:key/*')
  const activeKey = useMemo(() => match?.params.key || '', [match])

  return (
    <div className={classnames(styles.container, 'container-xl p-3')}>
      <div className={styles.sider}>
        <Menu
          mode='inline'
          className={'setting-menu'}
          selectedKeys={[activeKey]}
          onSelect={({ key }) => {
            navigate(key)
          }}
        >
          <Menu.Item key='profile' icon={<IconFont type={'icon-dashboard'} />}>
            Profile
          </Menu.Item>
        </Menu>
      </div>
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  )
})
